import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';
import { largeScreen, smallScreen } from '../../../../common/mixins';
import platform, { OS_TYPES } from '../../../../player/utils/platform';

const svgIconRules = ({ theme, isMobile }) => ({
  cursor: 'pointer',
  color: '#FFF',
  opacity: theme.opacity.enabled,
  height: theme.iconHeight.large,

  ':hover': {
    opacity: theme.opacity.hovered,
  },

  extend: [
    {
      condition: isMobile,
      style: {
        opacity: theme.opacity.hovered,
      },
    },
    largeScreen({
      height: theme.iconHeight.medium,
    }),
    smallScreen({
      height: theme.iconHeight.small,
    }),
  ],
});

const SvgIcon = (props) => {
  const isMobile = [OS_TYPES.IOS, OS_TYPES.ANDROID].includes(platform.os);
  const { css } = useFela({ isMobile });

  return (
    <svg
      className={css(svgIconRules)}
      {...props}
      data-cy="hp-fullscreen-button"
    />
  );
};

SvgIcon.propTypes = {
  children: PropTypes.node,
};

export default React.memo(SvgIcon);
